module.exports = __webpack_public_path__ + "img/梅花初级大师@3x.3eeb0b39.png";